var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-wrapper" }, [
    _c(
      "div",
      { staticClass: "confirmation" },
      [
        _c("card-header", {
          attrs: { title: "Join or create account?", designVersion: 2 },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "body" },
          [
            _c(
              "div",
              { staticClass: "spinner", class: { hidden: !_vm.isSubmitting } },
              [_c("i", { staticClass: "fa fa-spinner fa-pulse" })]
            ),
            _vm._v(" "),
            _c(
              "paragraph",
              {
                class: { hidden: _vm.isSubmitting },
                attrs: {
                  id: "already-registered-text",
                  type: "p",
                  variation: "medium",
                },
              },
              [
                _vm._v(
                  "\n                Your organization has an existing account. Would you like to join this account or create a new one?\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-group",
                class: { hidden: _vm.isSubmitting },
              },
              [
                _c(
                  "div",
                  { staticClass: "button-wrapper" },
                  [
                    !_vm.isSubmitting
                      ? _c("custom-button", {
                          attrs: {
                            text: "Join existing account",
                            id: "join-existing-account-btn",
                            size: "button-large",
                          },
                          on: { click: _vm.signUpWithExistingAccount },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "paragraph",
                      {
                        class: { hidden: _vm.isSubmitting },
                        attrs: { type: "p", variation: "medium" },
                      },
                      [
                        _vm._v(
                          "\n                        Or\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.isSubmitting
                      ? _c("custom-button", {
                          attrs: {
                            text: "Create new account",
                            id: "create-new-account-btn",
                            size: "button-large",
                          },
                          on: { click: _vm.signUp },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }